export default async function handleRecentlyViewed(element: HTMLElement) {
  try {
    if (window.innerWidth > 500) return;
    // Get recently viewed products from localStorage
    const recentlyViewed = JSON.parse(
      localStorage.getItem("helium-recently-viewed") || "[]",
    );
    const show = window.history.length < 3;
    if (!show) return;
    if (recentlyViewed.length === 0 || recentlyViewed.length < 2) {
      //console.warn("No recently viewed products found");
      return;
    }

    // Get product details for each recently viewed product
    const products = await Promise.all(
      recentlyViewed.map(async (productId: string) => {
        try {
          const product = await window.helium.datastore.getProduct({
            id: productId,
          });
          return product.details;
        } catch (error) {
          console.warn(`Failed to fetch product ${productId}:`, error);
          return null;
        }
      }),
    );
    const currentId = window.location.pathname.split("/").at(-1);

    const validProducts = products.filter(
      (product) => product && product.id !== currentId,
    );
    if (validProducts.length === 0) {
      console.warn("No valid products found");
      return;
    }

    const eleId = "helium-recently-viewed";
    let ele = document.getElementById(eleId);
    if (!ele) {
      ele = document.createElement("div");
      ele.classList.add("helium-pulse");
      ele.id = eleId;
      // Add styles for dotted border and background color
      ele.style.borderTop = "2px dotted #bbb";
      ele.style.borderBottom = "2px dotted #bbb";
      ele.style.background = "rgba(var(--brand-color-primary-rgb), 0.1)";
      ele.style.padding = "1rem";
      ele.style.margin = "1rem 0";

      // Always show product count for recently viewed, and pass rootStyle for border/background
      await window.helium.ui.renderInlineBlock(
        ele,
        validProducts,
        "You had your eyes on",
        undefined,
        "recently_viewed",
        {}, // event data
        {
          showCount: true,
          productCount: validProducts.length,
          rootStyle:
            "border-top:2px dashed #bbb;border-bottom:2px dashed #bbb;background:rgba(var(--brand-color-primary-rgb),0.1);padding:1rem;margin:1rem 0;",
          addToCart: false,
        },
      );

      ele.classList.add("hp-mx-4", "hp-pb-3", "hp-mt-8");
      element.appendChild(ele);
    }
  } catch (error) {
    console.error("Error in handleRecentlyViewed:", error);
  }
}
